var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 24.0035C7.37605 22.5671 5.87081 20.9923 4.49999 19.2957C2.44285 16.7479 1.13e-06 12.9534 1.13e-06 9.33756C-0.000891023 7.49093 0.52651 5.68553 1.51546 4.14985C2.50441 2.61416 3.91045 1.41722 5.55565 0.710509C7.20084 0.00379544 9.01123 -0.180924 10.7577 0.179727C12.5042 0.540378 14.1082 1.43019 15.3668 2.73655C16.2048 3.60165 16.869 4.6305 17.321 5.76356C17.7729 6.89663 18.0037 8.11139 18 9.33756C18 12.9534 15.5571 16.7479 13.5 19.2957C12.1291 20.9923 10.6239 22.5671 8.99998 24.0035ZM8.99998 5.33775C7.977 5.33775 6.99593 5.75916 6.27257 6.50927C5.54922 7.25938 5.14285 8.27674 5.14285 9.33756C5.14285 10.3984 5.54922 11.4157 6.27257 12.1658C6.99593 12.916 7.977 13.3374 8.99998 13.3374C10.023 13.3374 11.004 12.916 11.7274 12.1658C12.4507 11.4157 12.8571 10.3984 12.8571 9.33756C12.8571 8.27674 12.4507 7.25938 11.7274 6.50927C11.004 5.75916 10.023 5.33775 8.99998 5.33775Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.6699d1dc250f262a2d82ee75d6d10234.svg";
export { ForwardRef as ReactComponent };